module.exports = __webpack_public_path__ + "static/media/my-journy.0b9b3681.png";